<template>
  <div class="page partner">
    <div class="page-header">
      <button class="header-back" @click="$router.go(-1)"></button>
      <button class="header-nav-btn has-back" @click="$parent.$refs.nav.open()"></button>

      <span class="page-title"><span class="icon">Business Partners</span></span>

      <HeaderNav />
    </div>

    <div class="page-content" v-if="partner">
      <div class="page-container">
        <section class="partner-intro">
          <div class="partner-location">
            <span class="tour-side" v-if="partner.tour_side !== 'Unassigned'"><strong>{{partner.tour_side}}</strong></span>
              <a :href="`https://www.google.com/maps?q=${partner.coordinates}`" target="_blank" class="tour-address">{{partner.tour_address}} {{partner.tour_address_2}}<br> {{partner.tour_city}} {{partner.tour_zip}}</a>
          </div>

          <div class="partner-info">
            <h1><template v-if="partner.tour_number">{{partner.tour_number}}. </template> {{partner.business_name}}</h1>
            <i v-if="partner.category">{{partner.category.join(', ')}}</i>
          </div>

          <ul class="social-list">
            <li v-if="partner.instagram && partner.instagram.indexOf('http') > -1"><a :href="partner.instagram" class="social-account" target="_blank"><img src="../assets/img/instagram-black.svg" alt="Instagram"></a></li>
            <li v-if="partner.facebook && partner.facebook.indexOf('http') > -1"><a :href="partner.facebook" class="social-account" target="_blank"><img src="../assets/img/facebook-black.svg" alt="Facebook"></a></li>
            <li v-if="partner.twitter && partner.twitter.indexOf('http') > -1"><a :href="partner.twitter" class="social-account" target="_blank"><img src="../assets/img/twitter-black.svg" alt="Twitter"></a></li>
            <li v-if="partner.tiktok && partner.tiktok.indexOf('http') > -1"><a :href="partner.tiktok" class="social-account" target="_blank"><img src="../assets/img/tiktok-black.svg" alt="TikTok"></a></li>
          </ul>
        </section>

        <section class="partner-about">
          <div v-if="partner.featured_image" class="partner-image">
            <img :src="partner.featured_image.url" :alt="partner.featured_image.alt">
            <span v-if="partner.featured_image.caption" class="partner-image-name">{{partner.featured_image.caption}}</span>
          </div>

          <div class="partner-content">
            <h2 v-if="partner.about">About</h2>
            <p v-if="partner.about" v-html="partner.about"></p>
            <h2 v-if="partner.hosting">Hosting</h2>
            <p v-if="partner.hosting" v-html="partner.hosting"></p>
            <a v-if="partner.business_phone" :href="`tel:${partner.business_phone}`" @click="$root.openBrowser(`tel:${partner.business_phone}`)">{{partner.business_phone}}</a>
            <a v-if="partner.business_website && partner.business_website.indexOf('http') > -1" class="btn" :href="partner.business_website" target="_blank">Website</a>
          </div>

        </section>

        <Related v-if="partner.related" :item="partner" />
      </div>

      <Discover />
      <Supporters />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from "../mixins/SubPageUtils";

import HeaderNav from '../components/HeaderNav';
import Discover from '../components/Discover';
import Supporters from '../components/Supporters';
import Footer from '../components/Footer';
import Related from "../components/Related";

export default {
  name: 'Partner',
  mixins: [SubPageUtils],
  components: { HeaderNav, Supporters, Discover, Footer, Related },
  data() {
    return {
      partner: {},
    }
  },
  async mounted() {
    const response = await fetch(`${this.$root.api_url}getPartners?id=${this.$route.params.id}`)
    let partner = await response.json();
    this.partner = partner[0];
  },
};
</script>

<style lang="less" scoped>
@import '../css/variables';

.icon {
  background-image: url(../assets/img/icon-artists.svg);
  background-size: 18px 21px;
}

section {
  margin: 50px 0;
}

.partner-intro {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-content: space-between;
  align-items: center;
  @media (max-width: @mobile) {
    grid-template-columns: 1fr;
  }
  .partner-location {
    span {
      display: block;
    }
    .tour-side {
      text-transform: uppercase;
      color: @themeColor1;
    }
    a {
      color: #000;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .partner-info {
    text-align: center;
    @media (max-width: @mobile) {
      margin: 15px 0 30px 0;
    }
    h1 {
      margin-bottom: 10px;
    }
  }
  .social-list {
    display: flex;
    align-items: center;
    justify-self: flex-end;
    @media (max-width: @mobile) {
      justify-self: center;
    }
    li {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
    a {
      text-indent: -9999px;
    }
    img {
      width: 25px;
    }
  }
}

.partner-about {
  @media (min-width: @mobile) {
    display: flex;
  }
  .partner-image {
    margin-bottom: 20px;
    @media (min-width: @mobile) {
      width: 50%;
    }
    img {
      max-width: 100%;
    }
    .partner-image-name {
      font-family: @fontSecondary;
      font-size: 24px;
    }
  }

  .partner-content {
    margin-bottom: 20px;
    @media (min-width: @mobile) {
      width: 50%;
      padding-left: 40px;
    }
    h2,
    a:not(.btn) {
      font: bold 24px @fontPrimary;
      &:not(:first-child) {
        margin-top: 30px;
      }
    }
    h2 {
      margin-bottom: 5px;
    }
    p {
      line-height: 20px;
    }
    a:not(.btn) {
      display: block;
      font-size: 18px;
      color: #000;
    }
    .btn {
      margin-top: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Partner.vue